/* Step 02: sticky header surface and continuous announcement marquee.
 * The gate owns overlay triggers; step 15 owns Saved counts and behaviour.
 */
(function () {
  'use strict';

  var header;
  var scrollPending = false;
  var marqueePending = false;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateHeader() {
    if (!header) return;
    var isPhone = window.PBSPhone && window.PBSPhone.isPhone && window.PBSPhone.isPhone();
    header.classList.toggle('pbs-scrolled', !!isPhone && window.scrollY > 36);
  }

  function scheduleHeader() {
    if (scrollPending) return;
    scrollPending = true;
    window.requestAnimationFrame(function () {
      scrollPending = false;
      updateHeader();
    });
  }

  function headerScroll() {
    header = document.querySelector('.section-header');
    updateHeader();
  }

  // Keep the Liquid's two equal runs, repeating complete message sets inside
  // each when necessary. One original set always takes 42 seconds to pass.
  function fitMarquees() {
    marqueePending = false;
    document.querySelectorAll('.pbs-marquee').forEach(function (marquee) {
      var track = marquee.querySelector('.pbs-marquee__track');
      if (!track) return;
      var runs = track.querySelectorAll('.pbs-marquee__run');
      if (runs.length !== 2) return;
      track.querySelectorAll('[data-pbs-marquee-copy]').forEach(function (copy) { copy.remove(); });
      track.style.removeProperty('--pbs-mq-dur');
      if (reducedMotion.matches) return;

      var sourceWidth = runs[0].getBoundingClientRect().width;
      if (!sourceWidth) return;
      var repeatCount = Math.max(1, Math.ceil(marquee.clientWidth / sourceWidth));
      var sourceItems = Array.prototype.slice.call(runs[0].children);
      runs.forEach(function (run) {
        for (var i = 1; i < repeatCount; i += 1) {
          sourceItems.forEach(function (item) {
            var copy = item.cloneNode(true);
            copy.setAttribute('data-pbs-marquee-copy', '');
            copy.setAttribute('aria-hidden', 'true');
            // Editor selection belongs to the merchant's original blocks.
            Array.prototype.slice.call(copy.attributes).forEach(function (attribute) {
              if (attribute.name.indexOf('data-shopify-editor') === 0) copy.removeAttribute(attribute.name);
            });
            run.appendChild(copy);
          });
        }
      });
      track.style.setProperty('--pbs-mq-dur', (repeatCount * 42) + 's');
    });
  }

  function scheduleMarquees() {
    if (marqueePending) return;
    marqueePending = true;
    window.requestAnimationFrame(fitMarquees);
  }

  function init() {
    headerScroll();
    scheduleMarquees();
  }

  // These listeners are installed once, rather than inside section init.
  window.addEventListener('scroll', scheduleHeader, { passive: true });
  window.addEventListener('resize', function () {
    scheduleHeader();
    scheduleMarquees();
  }, { passive: true });
  document.addEventListener('shopify:section:load', init);
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', scheduleMarquees);
  else reducedMotion.addListener(scheduleMarquees);

  if (document.fonts) {
    document.fonts.ready.then(scheduleMarquees);
    document.fonts.addEventListener('loadingdone', scheduleMarquees);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
